import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
  return await axios.get(url, { params }).then((res) => {
    return res.data
  })
}

const useStoreBalanceStockRepositories = (params) => {
  const shouldFetch = params?.enabled !== false
  const requestParams = { ...params }

  delete requestParams.enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch && requestParams.outlet_id && requestParams.month
      ? [
          `${process.env.REACT_APP_INVENTORY_API_URL}/reports/store-balance-stock`,
          requestParams,
        ]
      : null,
    fetcher
  )

  return {
    data,
    isLoading:
      shouldFetch &&
      requestParams.outlet_id &&
      requestParams.month &&
      !error &&
      !data,
    error,
    isValidating,
    mutate,
  }
}

export default useStoreBalanceStockRepositories
